// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CartsDataViewContext } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageTitleCount from "@sc/App/Components/Common/PageTitleCount";
import React, { FC, useContext } from "react";

const SavedOrdersTitleCount: FC<WidgetProps> = () => {
    const SavedOrdersDataView = useContext(CartsDataViewContext);

    let totalItemCount = 0;

    if (SavedOrdersDataView.value && SavedOrdersDataView.pagination) {
        totalItemCount = SavedOrdersDataView.pagination.totalItemCount;
    }

    return <PageTitleCount countNumber={totalItemCount} countName="Order" />;
};

const widgetModule: WidgetModule = {
    component: SavedOrdersTitleCount,
    definition: {
        group: "Saved Order List",
        displayName: "Saved Orders Title Count",
        allowedContexts: ["SavedOrderListPage"],
    },
};

export default widgetModule;
